import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus, faTrash, faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faPlus, faTrash, faArrowUp, faArrowDown)

Vue.component('icon', FontAwesomeIcon)

Vue.config.productionTip = false;

const bus = new Vue();

new Vue({
  render: (h) => h(App),
  data: { bus }
}).$mount('#app');
